import type{ ComputedRef, Ref } from '@nuxtjs/composition-api';
import type { ProductVariant } from '~~/types/commercetools';
import { 
  getDiscountedPrice, 
  getFullProductPrice, 
  getFinalPrice, 
  getLast30DaysPrice, 
} from '~~/helpers/product/getPriceInfo';

type PriceInformationParameters = ComputedRef<number | null>;

export interface PriceInformation {
  fullProductPrice: PriceInformationParameters,
  discountedPrice: PriceInformationParameters,
  isDiscounted: ComputedRef<boolean>,
  finalPrice: PriceInformationParameters,
  last30DaysPrice: PriceInformationParameters,
}

export default function () {

  const getPriceInformation = (product: Ref<ProductVariant>): PriceInformation => {

    const fullProductPrice = computed(() => getFullProductPrice(product.value));
    const discountedPrice = computed(() => getDiscountedPrice(product.value));
    const isDiscounted = computed(() => !!discountedPrice.value);
    const finalPrice = computed(() => getFinalPrice(product.value));
    const last30DaysPrice = computed(() => getLast30DaysPrice(product.value));

    return {
      fullProductPrice,
      discountedPrice,
      isDiscounted,
      finalPrice,
      last30DaysPrice,
    };
  
  };

  return {
    getPriceInformation,
  };

}
